import { IMapLibrePolygonsStyle } from "@ryde/controls";

// A qualitative palette of visually distinct, modern hues used to color-code
// each area on the map. Colors cycle when there are more areas than entries.
export const AREA_POLYGON_COLORS: readonly string[] = [
  "#7B61FF", // purple
  "#FF8A00", // orange
  "#059A8F", // teal
  "#E91E8C", // pink
  "#448AFF", // blue
  "#C80815", // red
  "#35BF82", // green
  "#9400D3", // violet
  "#FB8C00", // amber
  "#3D70B2", // steel blue
  "#BA55D3", // orchid
  "#17620B", // forest green
  "#E0115F", // ruby
  "#6F00FF", // indigo
  "#FF6E40", // coral
  "#2A5184", // navy
] as const;

/**
 * How the areas map paints its polygons: resting, hovered, and — while one area is being reshaped —
 * dimmed into the background. These are the values the shared polygons layer defaults to, since the areas
 * map is its richest consumer, but they are passed explicitly so a change here cannot silently move the
 * stations map or the polygon viewer with it.
 */
export const AREA_POLYGONS_STYLE: IMapLibrePolygonsStyle = {
  fillOpacity: 0.3,
  weight: 2,
  hoverFillOpacity: 0.55,
  hoverWeight: 3,
  dimmedFillOpacity: 0.15,
  dimmedStrokeOpacity: 0.5,
  dimmedWeight: 1,
};

// The polygon currently under edit: a touch bolder than its resting style.
export const AREA_POLYGON_EDITING_FILL_OPACITY = 0.45;
export const AREA_POLYGON_EDITING_WEIGHT = 3;

export const AREA_POLYGONS_FIT_BOUNDS_PADDING_PX = 32;
